import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import {
    makeStyles,
    createMuiTheme,
    responsiveFontSizes,
    ThemeProvider
} from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import history from '../../../history';

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 600,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    cardContent: {
        maxHeight: 190,
        minHeight: 190,
        paddingTop: 0
    },
    cardHeader: {
        maxHeight: 100,
        minHeight: 100,
        paddingTop: 0,
        paddingBottom: 0
    },
}));

export default function CardCustom(props) {
    const classes = useStyles();

    function openDetailOpportunity(id) {
        history.push(`detalhes-vaga?id=${id}`)
    }

    let descriptionFormated = props.vaga.description
    if (descriptionFormated.length > 150) {
        descriptionFormated = `${props.vaga.description.substr(0, 150)}...`
    }

    function salaryFormatter(val) { return val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    let salarysFormataded = `${salaryFormatter(props.vaga.salary_min)} até ${salaryFormatter(props.vaga.salary_max)}`

    return (
        <>
            <Card className={classes.root} >
                <ThemeProvider theme={theme}>
                    <CardHeader
                        className={classes.cardHeader}
                        title={props.vaga.title}
                    />
                </ThemeProvider>
                <CardContent className={classes.cardContent}>
                    <ThemeProvider theme={theme}>
                        <Typography className={classes.cardContent} variant="body2" color="textSecondary" component="p">
                            <strong>Localização:</strong> {props.vaga.city.name} - {props.vaga.city.state.uf}<br />
                            <strong>Descrição:</strong> {descriptionFormated} {(props.vaga.isPdc) ? "- Vaga para PCD" : ""}<br />
                            <strong>Salário:</strong> {salarysFormataded}<br />
                            <strong>Tipo de Contrato:</strong> {props.vaga.type}<br />
                            <strong>Benefícios:</strong> {props.vaga.benefit}<br />
                        </Typography>
                    </ThemeProvider>
                </CardContent>

                <Box display="flex" justifyContent="flex-end">
                    <CardActions>
                        <Button variant="outlined" color="secondary" onClick={() => openDetailOpportunity(props.vaga.id)}>
                            Ver mais
                        </Button>
                    </CardActions>
                </Box>
            </Card>
        </>
    );
}
